'use strict';

var useInputValidation$1 = require('../../../../../../../../_virtual/useInputValidation.cjs');
var React = require('react');
require('./inputValidation.cjs');
var inputValidation$1 = require('../../../../../../../../_virtual/inputValidation.cjs');

var react = React;
var inputValidation = inputValidation$1.__exports;

/**
 * A hook used to run validations against inputs.
 */ const useInputValidation = (options)=>{
    const { isDirty, required, value, label } = options;
    const validationError = react.useMemo(()=>{
        if (!isDirty || !required && !inputValidation.isValuePresent(value)) return "";
        if (!inputValidation.isValuePresent(value)) return `${label} is required`;
        return "";
    }, [
        isDirty,
        required,
        value
    ]);
    return {
        validationError
    };
};

useInputValidation$1.__exports.useInputValidation = useInputValidation;

module.exports = useInputValidation$1.__exports;
//# sourceMappingURL=useInputValidation.cjs.map
